/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AutenticadoRouteImport } from './routes/_autenticado'
import { Route as DsRouteImport } from './routes/[_]ds'
import { Route as Ativar2faRouteImport } from './routes/ativar-2fa'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as EsqueciASenhaRouteImport } from './routes/esqueci-a-senha'
import { Route as RedefinirSenhaRouteImport } from './routes/redefinir-senha'
import { Route as AutenticadoIndexRouteImport } from './routes/_autenticado/index'
import { Route as AutenticadoMinhaContaRouteImport } from './routes/_autenticado/minha-conta'
import { Route as AutenticadoPlataformaRouteRouteImport } from './routes/_autenticado/plataforma/route'
import { Route as PagarTokenRouteImport } from './routes/pagar.$token'
import { Route as AutenticadoAlunosIndexRouteImport } from './routes/_autenticado/alunos/index'
import { Route as AutenticadoAlunosIdRouteImport } from './routes/_autenticado/alunos/$id'
import { Route as AutenticadoAtendimentosIndexRouteImport } from './routes/_autenticado/atendimentos/index'
import { Route as AutenticadoAtendimentosIdRouteImport } from './routes/_autenticado/atendimentos/$id'
import { Route as AutenticadoAtendimentosNovoRouteImport } from './routes/_autenticado/atendimentos/novo'
import { Route as AutenticadoAuditoriaIndexRouteImport } from './routes/_autenticado/auditoria/index'
import { Route as AutenticadoBannersIndexRouteImport } from './routes/_autenticado/banners/index'
import { Route as AutenticadoCadastrosIndexRouteImport } from './routes/_autenticado/cadastros/index'
import { Route as AutenticadoConfiguracoesEmpresaRouteImport } from './routes/_autenticado/configuracoes/empresa'
import { Route as AutenticadoCursosIndexRouteImport } from './routes/_autenticado/cursos/index'
import { Route as AutenticadoCursosIdRouteImport } from './routes/_autenticado/cursos/$id'
import { Route as AutenticadoDocumentosIndexRouteImport } from './routes/_autenticado/documentos/index'
import { Route as AutenticadoDocumentosIdRouteImport } from './routes/_autenticado/documentos/$id'
import { Route as AutenticadoEquipeIndexRouteImport } from './routes/_autenticado/equipe/index'
import { Route as AutenticadoExerciciosIndexRouteImport } from './routes/_autenticado/exercicios/index'
import { Route as AutenticadoExerciciosIdRouteImport } from './routes/_autenticado/exercicios/$id'
import { Route as AutenticadoFichasIndexRouteImport } from './routes/_autenticado/fichas/index'
import { Route as AutenticadoFichasIdRouteImport } from './routes/_autenticado/fichas/$id'
import { Route as AutenticadoPagamentosIndexRouteImport } from './routes/_autenticado/pagamentos/index'
import { Route as AutenticadoPagamentosIdRouteImport } from './routes/_autenticado/pagamentos/$id'
import { Route as AutenticadoPagamentosLinksRouteImport } from './routes/_autenticado/pagamentos/links'
import { Route as AutenticadoPlanosIndexRouteImport } from './routes/_autenticado/planos/index'
import { Route as AutenticadoPlanosIdRouteImport } from './routes/_autenticado/planos/$id'
import { Route as AutenticadoPlataformaIndexRouteImport } from './routes/_autenticado/plataforma/index'
import { Route as AutenticadoPlataformaAuditoriaRouteImport } from './routes/_autenticado/plataforma/auditoria'
import { Route as AutenticadoPlataformaCadastrosRouteImport } from './routes/_autenticado/plataforma/cadastros'
import { Route as AutenticadoPlataformaEmpresasRouteImport } from './routes/_autenticado/plataforma/empresas'
import { Route as AutenticadoPlataformaSuperAdminsRouteImport } from './routes/_autenticado/plataforma/super-admins'
import { Route as AutenticadoPlataformaTelasRouteImport } from './routes/_autenticado/plataforma/telas'
import { Route as AutenticadoRegistrosIndexRouteImport } from './routes/_autenticado/registros/index'
import { Route as AutenticadoEquipeFuncoesIndexRouteImport } from './routes/_autenticado/equipe/funcoes/index'
import { Route as AutenticadoEquipeFuncoesIdRouteImport } from './routes/_autenticado/equipe/funcoes/$id'
import { Route as AutenticadoEquipeFuncoesNovaRouteImport } from './routes/_autenticado/equipe/funcoes/nova'
import { Route as AutenticadoPlataformaPersonalizacaoIdRouteImport } from './routes/_autenticado/plataforma/personalizacao.$id'

const AutenticadoRoute = AutenticadoRouteImport.update({
  id: '/_autenticado',
  getParentRoute: () => rootRouteImport,
} as any)
const DsRoute = DsRouteImport.update({
  id: '/_ds',
  path: '/_ds',
  getParentRoute: () => rootRouteImport,
} as any)
const Ativar2faRoute = Ativar2faRouteImport.update({
  id: '/ativar-2fa',
  path: '/ativar-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const EsqueciASenhaRoute = EsqueciASenhaRouteImport.update({
  id: '/esqueci-a-senha',
  path: '/esqueci-a-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const RedefinirSenhaRoute = RedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const AutenticadoIndexRoute = AutenticadoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoMinhaContaRoute = AutenticadoMinhaContaRouteImport.update({
  id: '/minha-conta',
  path: '/minha-conta',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoPlataformaRouteRoute =
  AutenticadoPlataformaRouteRouteImport.update({
    id: '/plataforma',
    path: '/plataforma',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const PagarTokenRoute = PagarTokenRouteImport.update({
  id: '/pagar/$token',
  path: '/pagar/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AutenticadoAlunosIndexRoute = AutenticadoAlunosIndexRouteImport.update({
  id: '/alunos/',
  path: '/alunos/',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoAlunosIdRoute = AutenticadoAlunosIdRouteImport.update({
  id: '/alunos/$id',
  path: '/alunos/$id',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoAtendimentosIndexRoute =
  AutenticadoAtendimentosIndexRouteImport.update({
    id: '/atendimentos/',
    path: '/atendimentos/',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoAtendimentosIdRoute =
  AutenticadoAtendimentosIdRouteImport.update({
    id: '/atendimentos/$id',
    path: '/atendimentos/$id',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoAtendimentosNovoRoute =
  AutenticadoAtendimentosNovoRouteImport.update({
    id: '/atendimentos/novo',
    path: '/atendimentos/novo',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoAuditoriaIndexRoute =
  AutenticadoAuditoriaIndexRouteImport.update({
    id: '/auditoria/',
    path: '/auditoria/',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoBannersIndexRoute = AutenticadoBannersIndexRouteImport.update({
  id: '/banners/',
  path: '/banners/',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoCadastrosIndexRoute =
  AutenticadoCadastrosIndexRouteImport.update({
    id: '/cadastros/',
    path: '/cadastros/',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoConfiguracoesEmpresaRoute =
  AutenticadoConfiguracoesEmpresaRouteImport.update({
    id: '/configuracoes/empresa',
    path: '/configuracoes/empresa',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoCursosIndexRoute = AutenticadoCursosIndexRouteImport.update({
  id: '/cursos/',
  path: '/cursos/',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoCursosIdRoute = AutenticadoCursosIdRouteImport.update({
  id: '/cursos/$id',
  path: '/cursos/$id',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoDocumentosIndexRoute =
  AutenticadoDocumentosIndexRouteImport.update({
    id: '/documentos/',
    path: '/documentos/',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoDocumentosIdRoute = AutenticadoDocumentosIdRouteImport.update({
  id: '/documentos/$id',
  path: '/documentos/$id',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoEquipeIndexRoute = AutenticadoEquipeIndexRouteImport.update({
  id: '/equipe/',
  path: '/equipe/',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoExerciciosIndexRoute =
  AutenticadoExerciciosIndexRouteImport.update({
    id: '/exercicios/',
    path: '/exercicios/',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoExerciciosIdRoute = AutenticadoExerciciosIdRouteImport.update({
  id: '/exercicios/$id',
  path: '/exercicios/$id',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoFichasIndexRoute = AutenticadoFichasIndexRouteImport.update({
  id: '/fichas/',
  path: '/fichas/',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoFichasIdRoute = AutenticadoFichasIdRouteImport.update({
  id: '/fichas/$id',
  path: '/fichas/$id',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoPagamentosIndexRoute =
  AutenticadoPagamentosIndexRouteImport.update({
    id: '/pagamentos/',
    path: '/pagamentos/',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoPagamentosIdRoute = AutenticadoPagamentosIdRouteImport.update({
  id: '/pagamentos/$id',
  path: '/pagamentos/$id',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoPagamentosLinksRoute =
  AutenticadoPagamentosLinksRouteImport.update({
    id: '/pagamentos/links',
    path: '/pagamentos/links',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoPlanosIndexRoute = AutenticadoPlanosIndexRouteImport.update({
  id: '/planos/',
  path: '/planos/',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoPlanosIdRoute = AutenticadoPlanosIdRouteImport.update({
  id: '/planos/$id',
  path: '/planos/$id',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoPlataformaIndexRoute =
  AutenticadoPlataformaIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AutenticadoPlataformaRouteRoute,
  } as any)
const AutenticadoPlataformaAuditoriaRoute =
  AutenticadoPlataformaAuditoriaRouteImport.update({
    id: '/auditoria',
    path: '/auditoria',
    getParentRoute: () => AutenticadoPlataformaRouteRoute,
  } as any)
const AutenticadoPlataformaCadastrosRoute =
  AutenticadoPlataformaCadastrosRouteImport.update({
    id: '/cadastros',
    path: '/cadastros',
    getParentRoute: () => AutenticadoPlataformaRouteRoute,
  } as any)
const AutenticadoPlataformaEmpresasRoute =
  AutenticadoPlataformaEmpresasRouteImport.update({
    id: '/empresas',
    path: '/empresas',
    getParentRoute: () => AutenticadoPlataformaRouteRoute,
  } as any)
const AutenticadoPlataformaSuperAdminsRoute =
  AutenticadoPlataformaSuperAdminsRouteImport.update({
    id: '/super-admins',
    path: '/super-admins',
    getParentRoute: () => AutenticadoPlataformaRouteRoute,
  } as any)
const AutenticadoPlataformaTelasRoute =
  AutenticadoPlataformaTelasRouteImport.update({
    id: '/telas',
    path: '/telas',
    getParentRoute: () => AutenticadoPlataformaRouteRoute,
  } as any)
const AutenticadoRegistrosIndexRoute =
  AutenticadoRegistrosIndexRouteImport.update({
    id: '/registros/',
    path: '/registros/',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoEquipeFuncoesIndexRoute =
  AutenticadoEquipeFuncoesIndexRouteImport.update({
    id: '/equipe/funcoes/',
    path: '/equipe/funcoes/',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoEquipeFuncoesIdRoute =
  AutenticadoEquipeFuncoesIdRouteImport.update({
    id: '/equipe/funcoes/$id',
    path: '/equipe/funcoes/$id',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoEquipeFuncoesNovaRoute =
  AutenticadoEquipeFuncoesNovaRouteImport.update({
    id: '/equipe/funcoes/nova',
    path: '/equipe/funcoes/nova',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const AutenticadoPlataformaPersonalizacaoIdRoute =
  AutenticadoPlataformaPersonalizacaoIdRouteImport.update({
    id: '/personalizacao/$id',
    path: '/personalizacao/$id',
    getParentRoute: () => AutenticadoPlataformaRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AutenticadoIndexRoute
  '/_ds': typeof DsRoute
  '/ativar-2fa': typeof Ativar2faRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-a-senha': typeof EsqueciASenhaRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/plataforma': typeof AutenticadoPlataformaRouteRouteWithChildren
  '/minha-conta': typeof AutenticadoMinhaContaRoute
  '/pagar/$token': typeof PagarTokenRoute
  '/alunos/$id': typeof AutenticadoAlunosIdRoute
  '/atendimentos/$id': typeof AutenticadoAtendimentosIdRoute
  '/atendimentos/novo': typeof AutenticadoAtendimentosNovoRoute
  '/configuracoes/empresa': typeof AutenticadoConfiguracoesEmpresaRoute
  '/cursos/$id': typeof AutenticadoCursosIdRoute
  '/documentos/$id': typeof AutenticadoDocumentosIdRoute
  '/exercicios/$id': typeof AutenticadoExerciciosIdRoute
  '/fichas/$id': typeof AutenticadoFichasIdRoute
  '/pagamentos/$id': typeof AutenticadoPagamentosIdRoute
  '/pagamentos/links': typeof AutenticadoPagamentosLinksRoute
  '/planos/$id': typeof AutenticadoPlanosIdRoute
  '/plataforma/auditoria': typeof AutenticadoPlataformaAuditoriaRoute
  '/plataforma/cadastros': typeof AutenticadoPlataformaCadastrosRoute
  '/plataforma/empresas': typeof AutenticadoPlataformaEmpresasRoute
  '/plataforma/super-admins': typeof AutenticadoPlataformaSuperAdminsRoute
  '/plataforma/telas': typeof AutenticadoPlataformaTelasRoute
  '/alunos/': typeof AutenticadoAlunosIndexRoute
  '/atendimentos/': typeof AutenticadoAtendimentosIndexRoute
  '/auditoria/': typeof AutenticadoAuditoriaIndexRoute
  '/banners/': typeof AutenticadoBannersIndexRoute
  '/cadastros/': typeof AutenticadoCadastrosIndexRoute
  '/cursos/': typeof AutenticadoCursosIndexRoute
  '/documentos/': typeof AutenticadoDocumentosIndexRoute
  '/equipe/': typeof AutenticadoEquipeIndexRoute
  '/exercicios/': typeof AutenticadoExerciciosIndexRoute
  '/fichas/': typeof AutenticadoFichasIndexRoute
  '/pagamentos/': typeof AutenticadoPagamentosIndexRoute
  '/planos/': typeof AutenticadoPlanosIndexRoute
  '/plataforma/': typeof AutenticadoPlataformaIndexRoute
  '/registros/': typeof AutenticadoRegistrosIndexRoute
  '/equipe/funcoes/$id': typeof AutenticadoEquipeFuncoesIdRoute
  '/equipe/funcoes/nova': typeof AutenticadoEquipeFuncoesNovaRoute
  '/plataforma/personalizacao/$id': typeof AutenticadoPlataformaPersonalizacaoIdRoute
  '/equipe/funcoes/': typeof AutenticadoEquipeFuncoesIndexRoute
}
export interface FileRoutesByTo {
  '/_ds': typeof DsRoute
  '/ativar-2fa': typeof Ativar2faRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-a-senha': typeof EsqueciASenhaRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/minha-conta': typeof AutenticadoMinhaContaRoute
  '/pagar/$token': typeof PagarTokenRoute
  '/': typeof AutenticadoIndexRoute
  '/alunos/$id': typeof AutenticadoAlunosIdRoute
  '/atendimentos/$id': typeof AutenticadoAtendimentosIdRoute
  '/atendimentos/novo': typeof AutenticadoAtendimentosNovoRoute
  '/configuracoes/empresa': typeof AutenticadoConfiguracoesEmpresaRoute
  '/cursos/$id': typeof AutenticadoCursosIdRoute
  '/documentos/$id': typeof AutenticadoDocumentosIdRoute
  '/exercicios/$id': typeof AutenticadoExerciciosIdRoute
  '/fichas/$id': typeof AutenticadoFichasIdRoute
  '/pagamentos/$id': typeof AutenticadoPagamentosIdRoute
  '/pagamentos/links': typeof AutenticadoPagamentosLinksRoute
  '/planos/$id': typeof AutenticadoPlanosIdRoute
  '/plataforma/auditoria': typeof AutenticadoPlataformaAuditoriaRoute
  '/plataforma/cadastros': typeof AutenticadoPlataformaCadastrosRoute
  '/plataforma/empresas': typeof AutenticadoPlataformaEmpresasRoute
  '/plataforma/super-admins': typeof AutenticadoPlataformaSuperAdminsRoute
  '/plataforma/telas': typeof AutenticadoPlataformaTelasRoute
  '/alunos': typeof AutenticadoAlunosIndexRoute
  '/atendimentos': typeof AutenticadoAtendimentosIndexRoute
  '/auditoria': typeof AutenticadoAuditoriaIndexRoute
  '/banners': typeof AutenticadoBannersIndexRoute
  '/cadastros': typeof AutenticadoCadastrosIndexRoute
  '/cursos': typeof AutenticadoCursosIndexRoute
  '/documentos': typeof AutenticadoDocumentosIndexRoute
  '/equipe': typeof AutenticadoEquipeIndexRoute
  '/exercicios': typeof AutenticadoExerciciosIndexRoute
  '/fichas': typeof AutenticadoFichasIndexRoute
  '/pagamentos': typeof AutenticadoPagamentosIndexRoute
  '/planos': typeof AutenticadoPlanosIndexRoute
  '/plataforma': typeof AutenticadoPlataformaIndexRoute
  '/registros': typeof AutenticadoRegistrosIndexRoute
  '/equipe/funcoes/$id': typeof AutenticadoEquipeFuncoesIdRoute
  '/equipe/funcoes/nova': typeof AutenticadoEquipeFuncoesNovaRoute
  '/plataforma/personalizacao/$id': typeof AutenticadoPlataformaPersonalizacaoIdRoute
  '/equipe/funcoes': typeof AutenticadoEquipeFuncoesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_autenticado': typeof AutenticadoRouteWithChildren
  '/_ds': typeof DsRoute
  '/ativar-2fa': typeof Ativar2faRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-a-senha': typeof EsqueciASenhaRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/_autenticado/plataforma': typeof AutenticadoPlataformaRouteRouteWithChildren
  '/_autenticado/minha-conta': typeof AutenticadoMinhaContaRoute
  '/pagar/$token': typeof PagarTokenRoute
  '/_autenticado/': typeof AutenticadoIndexRoute
  '/_autenticado/alunos/$id': typeof AutenticadoAlunosIdRoute
  '/_autenticado/atendimentos/$id': typeof AutenticadoAtendimentosIdRoute
  '/_autenticado/atendimentos/novo': typeof AutenticadoAtendimentosNovoRoute
  '/_autenticado/configuracoes/empresa': typeof AutenticadoConfiguracoesEmpresaRoute
  '/_autenticado/cursos/$id': typeof AutenticadoCursosIdRoute
  '/_autenticado/documentos/$id': typeof AutenticadoDocumentosIdRoute
  '/_autenticado/exercicios/$id': typeof AutenticadoExerciciosIdRoute
  '/_autenticado/fichas/$id': typeof AutenticadoFichasIdRoute
  '/_autenticado/pagamentos/$id': typeof AutenticadoPagamentosIdRoute
  '/_autenticado/pagamentos/links': typeof AutenticadoPagamentosLinksRoute
  '/_autenticado/planos/$id': typeof AutenticadoPlanosIdRoute
  '/_autenticado/plataforma/auditoria': typeof AutenticadoPlataformaAuditoriaRoute
  '/_autenticado/plataforma/cadastros': typeof AutenticadoPlataformaCadastrosRoute
  '/_autenticado/plataforma/empresas': typeof AutenticadoPlataformaEmpresasRoute
  '/_autenticado/plataforma/super-admins': typeof AutenticadoPlataformaSuperAdminsRoute
  '/_autenticado/plataforma/telas': typeof AutenticadoPlataformaTelasRoute
  '/_autenticado/alunos/': typeof AutenticadoAlunosIndexRoute
  '/_autenticado/atendimentos/': typeof AutenticadoAtendimentosIndexRoute
  '/_autenticado/auditoria/': typeof AutenticadoAuditoriaIndexRoute
  '/_autenticado/banners/': typeof AutenticadoBannersIndexRoute
  '/_autenticado/cadastros/': typeof AutenticadoCadastrosIndexRoute
  '/_autenticado/cursos/': typeof AutenticadoCursosIndexRoute
  '/_autenticado/documentos/': typeof AutenticadoDocumentosIndexRoute
  '/_autenticado/equipe/': typeof AutenticadoEquipeIndexRoute
  '/_autenticado/exercicios/': typeof AutenticadoExerciciosIndexRoute
  '/_autenticado/fichas/': typeof AutenticadoFichasIndexRoute
  '/_autenticado/pagamentos/': typeof AutenticadoPagamentosIndexRoute
  '/_autenticado/planos/': typeof AutenticadoPlanosIndexRoute
  '/_autenticado/plataforma/': typeof AutenticadoPlataformaIndexRoute
  '/_autenticado/registros/': typeof AutenticadoRegistrosIndexRoute
  '/_autenticado/equipe/funcoes/$id': typeof AutenticadoEquipeFuncoesIdRoute
  '/_autenticado/equipe/funcoes/nova': typeof AutenticadoEquipeFuncoesNovaRoute
  '/_autenticado/plataforma/personalizacao/$id': typeof AutenticadoPlataformaPersonalizacaoIdRoute
  '/_autenticado/equipe/funcoes/': typeof AutenticadoEquipeFuncoesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/_ds'
    | '/ativar-2fa'
    | '/entrar'
    | '/esqueci-a-senha'
    | '/redefinir-senha'
    | '/plataforma'
    | '/minha-conta'
    | '/pagar/$token'
    | '/alunos/$id'
    | '/atendimentos/$id'
    | '/atendimentos/novo'
    | '/configuracoes/empresa'
    | '/cursos/$id'
    | '/documentos/$id'
    | '/exercicios/$id'
    | '/fichas/$id'
    | '/pagamentos/$id'
    | '/pagamentos/links'
    | '/planos/$id'
    | '/plataforma/auditoria'
    | '/plataforma/cadastros'
    | '/plataforma/empresas'
    | '/plataforma/super-admins'
    | '/plataforma/telas'
    | '/alunos/'
    | '/atendimentos/'
    | '/auditoria/'
    | '/banners/'
    | '/cadastros/'
    | '/cursos/'
    | '/documentos/'
    | '/equipe/'
    | '/exercicios/'
    | '/fichas/'
    | '/pagamentos/'
    | '/planos/'
    | '/plataforma/'
    | '/registros/'
    | '/equipe/funcoes/$id'
    | '/equipe/funcoes/nova'
    | '/plataforma/personalizacao/$id'
    | '/equipe/funcoes/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/_ds'
    | '/ativar-2fa'
    | '/entrar'
    | '/esqueci-a-senha'
    | '/redefinir-senha'
    | '/minha-conta'
    | '/pagar/$token'
    | '/'
    | '/alunos/$id'
    | '/atendimentos/$id'
    | '/atendimentos/novo'
    | '/configuracoes/empresa'
    | '/cursos/$id'
    | '/documentos/$id'
    | '/exercicios/$id'
    | '/fichas/$id'
    | '/pagamentos/$id'
    | '/pagamentos/links'
    | '/planos/$id'
    | '/plataforma/auditoria'
    | '/plataforma/cadastros'
    | '/plataforma/empresas'
    | '/plataforma/super-admins'
    | '/plataforma/telas'
    | '/alunos'
    | '/atendimentos'
    | '/auditoria'
    | '/banners'
    | '/cadastros'
    | '/cursos'
    | '/documentos'
    | '/equipe'
    | '/exercicios'
    | '/fichas'
    | '/pagamentos'
    | '/planos'
    | '/plataforma'
    | '/registros'
    | '/equipe/funcoes/$id'
    | '/equipe/funcoes/nova'
    | '/plataforma/personalizacao/$id'
    | '/equipe/funcoes'
  id:
    | '__root__'
    | '/_autenticado'
    | '/_ds'
    | '/ativar-2fa'
    | '/entrar'
    | '/esqueci-a-senha'
    | '/redefinir-senha'
    | '/_autenticado/plataforma'
    | '/_autenticado/minha-conta'
    | '/pagar/$token'
    | '/_autenticado/'
    | '/_autenticado/alunos/$id'
    | '/_autenticado/atendimentos/$id'
    | '/_autenticado/atendimentos/novo'
    | '/_autenticado/configuracoes/empresa'
    | '/_autenticado/cursos/$id'
    | '/_autenticado/documentos/$id'
    | '/_autenticado/exercicios/$id'
    | '/_autenticado/fichas/$id'
    | '/_autenticado/pagamentos/$id'
    | '/_autenticado/pagamentos/links'
    | '/_autenticado/planos/$id'
    | '/_autenticado/plataforma/auditoria'
    | '/_autenticado/plataforma/cadastros'
    | '/_autenticado/plataforma/empresas'
    | '/_autenticado/plataforma/super-admins'
    | '/_autenticado/plataforma/telas'
    | '/_autenticado/alunos/'
    | '/_autenticado/atendimentos/'
    | '/_autenticado/auditoria/'
    | '/_autenticado/banners/'
    | '/_autenticado/cadastros/'
    | '/_autenticado/cursos/'
    | '/_autenticado/documentos/'
    | '/_autenticado/equipe/'
    | '/_autenticado/exercicios/'
    | '/_autenticado/fichas/'
    | '/_autenticado/pagamentos/'
    | '/_autenticado/planos/'
    | '/_autenticado/plataforma/'
    | '/_autenticado/registros/'
    | '/_autenticado/equipe/funcoes/$id'
    | '/_autenticado/equipe/funcoes/nova'
    | '/_autenticado/plataforma/personalizacao/$id'
    | '/_autenticado/equipe/funcoes/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AutenticadoRoute: typeof AutenticadoRouteWithChildren
  DsRoute: typeof DsRoute
  Ativar2faRoute: typeof Ativar2faRoute
  EntrarRoute: typeof EntrarRoute
  EsqueciASenhaRoute: typeof EsqueciASenhaRoute
  RedefinirSenhaRoute: typeof RedefinirSenhaRoute
  PagarTokenRoute: typeof PagarTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_autenticado': {
      id: '/_autenticado'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AutenticadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_ds': {
      id: '/_ds'
      path: '/_ds'
      fullPath: '/_ds'
      preLoaderRoute: typeof DsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ativar-2fa': {
      id: '/ativar-2fa'
      path: '/ativar-2fa'
      fullPath: '/ativar-2fa'
      preLoaderRoute: typeof Ativar2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/esqueci-a-senha': {
      id: '/esqueci-a-senha'
      path: '/esqueci-a-senha'
      fullPath: '/esqueci-a-senha'
      preLoaderRoute: typeof EsqueciASenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redefinir-senha': {
      id: '/redefinir-senha'
      path: '/redefinir-senha'
      fullPath: '/redefinir-senha'
      preLoaderRoute: typeof RedefinirSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_autenticado/': {
      id: '/_autenticado/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AutenticadoIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/minha-conta': {
      id: '/_autenticado/minha-conta'
      path: '/minha-conta'
      fullPath: '/minha-conta'
      preLoaderRoute: typeof AutenticadoMinhaContaRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/plataforma': {
      id: '/_autenticado/plataforma'
      path: '/plataforma'
      fullPath: '/plataforma'
      preLoaderRoute: typeof AutenticadoPlataformaRouteRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/pagar/$token': {
      id: '/pagar/$token'
      path: '/pagar/$token'
      fullPath: '/pagar/$token'
      preLoaderRoute: typeof PagarTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_autenticado/alunos/': {
      id: '/_autenticado/alunos/'
      path: '/alunos'
      fullPath: '/alunos/'
      preLoaderRoute: typeof AutenticadoAlunosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/alunos/$id': {
      id: '/_autenticado/alunos/$id'
      path: '/alunos/$id'
      fullPath: '/alunos/$id'
      preLoaderRoute: typeof AutenticadoAlunosIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/atendimentos/': {
      id: '/_autenticado/atendimentos/'
      path: '/atendimentos'
      fullPath: '/atendimentos/'
      preLoaderRoute: typeof AutenticadoAtendimentosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/atendimentos/$id': {
      id: '/_autenticado/atendimentos/$id'
      path: '/atendimentos/$id'
      fullPath: '/atendimentos/$id'
      preLoaderRoute: typeof AutenticadoAtendimentosIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/atendimentos/novo': {
      id: '/_autenticado/atendimentos/novo'
      path: '/atendimentos/novo'
      fullPath: '/atendimentos/novo'
      preLoaderRoute: typeof AutenticadoAtendimentosNovoRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/auditoria/': {
      id: '/_autenticado/auditoria/'
      path: '/auditoria'
      fullPath: '/auditoria/'
      preLoaderRoute: typeof AutenticadoAuditoriaIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/banners/': {
      id: '/_autenticado/banners/'
      path: '/banners'
      fullPath: '/banners/'
      preLoaderRoute: typeof AutenticadoBannersIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/cadastros/': {
      id: '/_autenticado/cadastros/'
      path: '/cadastros'
      fullPath: '/cadastros/'
      preLoaderRoute: typeof AutenticadoCadastrosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/configuracoes/empresa': {
      id: '/_autenticado/configuracoes/empresa'
      path: '/configuracoes/empresa'
      fullPath: '/configuracoes/empresa'
      preLoaderRoute: typeof AutenticadoConfiguracoesEmpresaRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/cursos/': {
      id: '/_autenticado/cursos/'
      path: '/cursos'
      fullPath: '/cursos/'
      preLoaderRoute: typeof AutenticadoCursosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/cursos/$id': {
      id: '/_autenticado/cursos/$id'
      path: '/cursos/$id'
      fullPath: '/cursos/$id'
      preLoaderRoute: typeof AutenticadoCursosIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/documentos/': {
      id: '/_autenticado/documentos/'
      path: '/documentos'
      fullPath: '/documentos/'
      preLoaderRoute: typeof AutenticadoDocumentosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/documentos/$id': {
      id: '/_autenticado/documentos/$id'
      path: '/documentos/$id'
      fullPath: '/documentos/$id'
      preLoaderRoute: typeof AutenticadoDocumentosIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/equipe/': {
      id: '/_autenticado/equipe/'
      path: '/equipe'
      fullPath: '/equipe/'
      preLoaderRoute: typeof AutenticadoEquipeIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/exercicios/': {
      id: '/_autenticado/exercicios/'
      path: '/exercicios'
      fullPath: '/exercicios/'
      preLoaderRoute: typeof AutenticadoExerciciosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/exercicios/$id': {
      id: '/_autenticado/exercicios/$id'
      path: '/exercicios/$id'
      fullPath: '/exercicios/$id'
      preLoaderRoute: typeof AutenticadoExerciciosIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/fichas/': {
      id: '/_autenticado/fichas/'
      path: '/fichas'
      fullPath: '/fichas/'
      preLoaderRoute: typeof AutenticadoFichasIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/fichas/$id': {
      id: '/_autenticado/fichas/$id'
      path: '/fichas/$id'
      fullPath: '/fichas/$id'
      preLoaderRoute: typeof AutenticadoFichasIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/pagamentos/': {
      id: '/_autenticado/pagamentos/'
      path: '/pagamentos'
      fullPath: '/pagamentos/'
      preLoaderRoute: typeof AutenticadoPagamentosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/pagamentos/$id': {
      id: '/_autenticado/pagamentos/$id'
      path: '/pagamentos/$id'
      fullPath: '/pagamentos/$id'
      preLoaderRoute: typeof AutenticadoPagamentosIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/pagamentos/links': {
      id: '/_autenticado/pagamentos/links'
      path: '/pagamentos/links'
      fullPath: '/pagamentos/links'
      preLoaderRoute: typeof AutenticadoPagamentosLinksRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/planos/': {
      id: '/_autenticado/planos/'
      path: '/planos'
      fullPath: '/planos/'
      preLoaderRoute: typeof AutenticadoPlanosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/planos/$id': {
      id: '/_autenticado/planos/$id'
      path: '/planos/$id'
      fullPath: '/planos/$id'
      preLoaderRoute: typeof AutenticadoPlanosIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/plataforma/': {
      id: '/_autenticado/plataforma/'
      path: '/'
      fullPath: '/plataforma/'
      preLoaderRoute: typeof AutenticadoPlataformaIndexRouteImport
      parentRoute: typeof AutenticadoPlataformaRouteRoute
    }
    '/_autenticado/plataforma/auditoria': {
      id: '/_autenticado/plataforma/auditoria'
      path: '/auditoria'
      fullPath: '/plataforma/auditoria'
      preLoaderRoute: typeof AutenticadoPlataformaAuditoriaRouteImport
      parentRoute: typeof AutenticadoPlataformaRouteRoute
    }
    '/_autenticado/plataforma/cadastros': {
      id: '/_autenticado/plataforma/cadastros'
      path: '/cadastros'
      fullPath: '/plataforma/cadastros'
      preLoaderRoute: typeof AutenticadoPlataformaCadastrosRouteImport
      parentRoute: typeof AutenticadoPlataformaRouteRoute
    }
    '/_autenticado/plataforma/empresas': {
      id: '/_autenticado/plataforma/empresas'
      path: '/empresas'
      fullPath: '/plataforma/empresas'
      preLoaderRoute: typeof AutenticadoPlataformaEmpresasRouteImport
      parentRoute: typeof AutenticadoPlataformaRouteRoute
    }
    '/_autenticado/plataforma/super-admins': {
      id: '/_autenticado/plataforma/super-admins'
      path: '/super-admins'
      fullPath: '/plataforma/super-admins'
      preLoaderRoute: typeof AutenticadoPlataformaSuperAdminsRouteImport
      parentRoute: typeof AutenticadoPlataformaRouteRoute
    }
    '/_autenticado/plataforma/telas': {
      id: '/_autenticado/plataforma/telas'
      path: '/telas'
      fullPath: '/plataforma/telas'
      preLoaderRoute: typeof AutenticadoPlataformaTelasRouteImport
      parentRoute: typeof AutenticadoPlataformaRouteRoute
    }
    '/_autenticado/registros/': {
      id: '/_autenticado/registros/'
      path: '/registros'
      fullPath: '/registros/'
      preLoaderRoute: typeof AutenticadoRegistrosIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/equipe/funcoes/': {
      id: '/_autenticado/equipe/funcoes/'
      path: '/equipe/funcoes'
      fullPath: '/equipe/funcoes/'
      preLoaderRoute: typeof AutenticadoEquipeFuncoesIndexRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/equipe/funcoes/$id': {
      id: '/_autenticado/equipe/funcoes/$id'
      path: '/equipe/funcoes/$id'
      fullPath: '/equipe/funcoes/$id'
      preLoaderRoute: typeof AutenticadoEquipeFuncoesIdRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/equipe/funcoes/nova': {
      id: '/_autenticado/equipe/funcoes/nova'
      path: '/equipe/funcoes/nova'
      fullPath: '/equipe/funcoes/nova'
      preLoaderRoute: typeof AutenticadoEquipeFuncoesNovaRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/plataforma/personalizacao/$id': {
      id: '/_autenticado/plataforma/personalizacao/$id'
      path: '/personalizacao/$id'
      fullPath: '/plataforma/personalizacao/$id'
      preLoaderRoute: typeof AutenticadoPlataformaPersonalizacaoIdRouteImport
      parentRoute: typeof AutenticadoPlataformaRouteRoute
    }
  }
}

interface AutenticadoPlataformaRouteRouteChildren {
  AutenticadoPlataformaAuditoriaRoute: typeof AutenticadoPlataformaAuditoriaRoute
  AutenticadoPlataformaCadastrosRoute: typeof AutenticadoPlataformaCadastrosRoute
  AutenticadoPlataformaEmpresasRoute: typeof AutenticadoPlataformaEmpresasRoute
  AutenticadoPlataformaSuperAdminsRoute: typeof AutenticadoPlataformaSuperAdminsRoute
  AutenticadoPlataformaTelasRoute: typeof AutenticadoPlataformaTelasRoute
  AutenticadoPlataformaIndexRoute: typeof AutenticadoPlataformaIndexRoute
  AutenticadoPlataformaPersonalizacaoIdRoute: typeof AutenticadoPlataformaPersonalizacaoIdRoute
}

const AutenticadoPlataformaRouteRouteChildren: AutenticadoPlataformaRouteRouteChildren =
  {
    AutenticadoPlataformaAuditoriaRoute: AutenticadoPlataformaAuditoriaRoute,
    AutenticadoPlataformaCadastrosRoute: AutenticadoPlataformaCadastrosRoute,
    AutenticadoPlataformaEmpresasRoute: AutenticadoPlataformaEmpresasRoute,
    AutenticadoPlataformaSuperAdminsRoute:
      AutenticadoPlataformaSuperAdminsRoute,
    AutenticadoPlataformaTelasRoute: AutenticadoPlataformaTelasRoute,
    AutenticadoPlataformaIndexRoute: AutenticadoPlataformaIndexRoute,
    AutenticadoPlataformaPersonalizacaoIdRoute:
      AutenticadoPlataformaPersonalizacaoIdRoute,
  }

const AutenticadoPlataformaRouteRouteWithChildren =
  AutenticadoPlataformaRouteRoute._addFileChildren(
    AutenticadoPlataformaRouteRouteChildren,
  )

interface AutenticadoRouteChildren {
  AutenticadoPlataformaRouteRoute: typeof AutenticadoPlataformaRouteRouteWithChildren
  AutenticadoMinhaContaRoute: typeof AutenticadoMinhaContaRoute
  AutenticadoIndexRoute: typeof AutenticadoIndexRoute
  AutenticadoAlunosIdRoute: typeof AutenticadoAlunosIdRoute
  AutenticadoAtendimentosIdRoute: typeof AutenticadoAtendimentosIdRoute
  AutenticadoAtendimentosNovoRoute: typeof AutenticadoAtendimentosNovoRoute
  AutenticadoConfiguracoesEmpresaRoute: typeof AutenticadoConfiguracoesEmpresaRoute
  AutenticadoCursosIdRoute: typeof AutenticadoCursosIdRoute
  AutenticadoDocumentosIdRoute: typeof AutenticadoDocumentosIdRoute
  AutenticadoExerciciosIdRoute: typeof AutenticadoExerciciosIdRoute
  AutenticadoFichasIdRoute: typeof AutenticadoFichasIdRoute
  AutenticadoPagamentosIdRoute: typeof AutenticadoPagamentosIdRoute
  AutenticadoPagamentosLinksRoute: typeof AutenticadoPagamentosLinksRoute
  AutenticadoPlanosIdRoute: typeof AutenticadoPlanosIdRoute
  AutenticadoAlunosIndexRoute: typeof AutenticadoAlunosIndexRoute
  AutenticadoAtendimentosIndexRoute: typeof AutenticadoAtendimentosIndexRoute
  AutenticadoAuditoriaIndexRoute: typeof AutenticadoAuditoriaIndexRoute
  AutenticadoBannersIndexRoute: typeof AutenticadoBannersIndexRoute
  AutenticadoCadastrosIndexRoute: typeof AutenticadoCadastrosIndexRoute
  AutenticadoCursosIndexRoute: typeof AutenticadoCursosIndexRoute
  AutenticadoDocumentosIndexRoute: typeof AutenticadoDocumentosIndexRoute
  AutenticadoEquipeIndexRoute: typeof AutenticadoEquipeIndexRoute
  AutenticadoExerciciosIndexRoute: typeof AutenticadoExerciciosIndexRoute
  AutenticadoFichasIndexRoute: typeof AutenticadoFichasIndexRoute
  AutenticadoPagamentosIndexRoute: typeof AutenticadoPagamentosIndexRoute
  AutenticadoPlanosIndexRoute: typeof AutenticadoPlanosIndexRoute
  AutenticadoRegistrosIndexRoute: typeof AutenticadoRegistrosIndexRoute
  AutenticadoEquipeFuncoesIdRoute: typeof AutenticadoEquipeFuncoesIdRoute
  AutenticadoEquipeFuncoesNovaRoute: typeof AutenticadoEquipeFuncoesNovaRoute
  AutenticadoEquipeFuncoesIndexRoute: typeof AutenticadoEquipeFuncoesIndexRoute
}

const AutenticadoRouteChildren: AutenticadoRouteChildren = {
  AutenticadoPlataformaRouteRoute: AutenticadoPlataformaRouteRouteWithChildren,
  AutenticadoMinhaContaRoute: AutenticadoMinhaContaRoute,
  AutenticadoIndexRoute: AutenticadoIndexRoute,
  AutenticadoAlunosIdRoute: AutenticadoAlunosIdRoute,
  AutenticadoAtendimentosIdRoute: AutenticadoAtendimentosIdRoute,
  AutenticadoAtendimentosNovoRoute: AutenticadoAtendimentosNovoRoute,
  AutenticadoConfiguracoesEmpresaRoute: AutenticadoConfiguracoesEmpresaRoute,
  AutenticadoCursosIdRoute: AutenticadoCursosIdRoute,
  AutenticadoDocumentosIdRoute: AutenticadoDocumentosIdRoute,
  AutenticadoExerciciosIdRoute: AutenticadoExerciciosIdRoute,
  AutenticadoFichasIdRoute: AutenticadoFichasIdRoute,
  AutenticadoPagamentosIdRoute: AutenticadoPagamentosIdRoute,
  AutenticadoPagamentosLinksRoute: AutenticadoPagamentosLinksRoute,
  AutenticadoPlanosIdRoute: AutenticadoPlanosIdRoute,
  AutenticadoAlunosIndexRoute: AutenticadoAlunosIndexRoute,
  AutenticadoAtendimentosIndexRoute: AutenticadoAtendimentosIndexRoute,
  AutenticadoAuditoriaIndexRoute: AutenticadoAuditoriaIndexRoute,
  AutenticadoBannersIndexRoute: AutenticadoBannersIndexRoute,
  AutenticadoCadastrosIndexRoute: AutenticadoCadastrosIndexRoute,
  AutenticadoCursosIndexRoute: AutenticadoCursosIndexRoute,
  AutenticadoDocumentosIndexRoute: AutenticadoDocumentosIndexRoute,
  AutenticadoEquipeIndexRoute: AutenticadoEquipeIndexRoute,
  AutenticadoExerciciosIndexRoute: AutenticadoExerciciosIndexRoute,
  AutenticadoFichasIndexRoute: AutenticadoFichasIndexRoute,
  AutenticadoPagamentosIndexRoute: AutenticadoPagamentosIndexRoute,
  AutenticadoPlanosIndexRoute: AutenticadoPlanosIndexRoute,
  AutenticadoRegistrosIndexRoute: AutenticadoRegistrosIndexRoute,
  AutenticadoEquipeFuncoesIdRoute: AutenticadoEquipeFuncoesIdRoute,
  AutenticadoEquipeFuncoesNovaRoute: AutenticadoEquipeFuncoesNovaRoute,
  AutenticadoEquipeFuncoesIndexRoute: AutenticadoEquipeFuncoesIndexRoute,
}

const AutenticadoRouteWithChildren = AutenticadoRoute._addFileChildren(
  AutenticadoRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AutenticadoRoute: AutenticadoRouteWithChildren,
  DsRoute: DsRoute,
  Ativar2faRoute: Ativar2faRoute,
  EntrarRoute: EntrarRoute,
  EsqueciASenhaRoute: EsqueciASenhaRoute,
  RedefinirSenhaRoute: RedefinirSenhaRoute,
  PagarTokenRoute: PagarTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
